<app-header></app-header>

<div class="min-h-screen tema-claro">
  <div class="max-w-6xl mx-auto p-6">

    <!-- Breadcrumb -->
    <div class="mb-6 flex items-center gap-2 text-xs" style="color: var(--tx-2)">
      <a routerLink="/home" class="hover:underline" style="color: var(--brand-primary)">Início</a>
      <span>/</span>
      <a routerLink="/lancamentos-financeiros" class="hover:underline" style="color: var(--brand-primary)">Lançamentos Financeiros</a>
      <span>/</span>
      <span class="font-semibold" style="color: var(--tx)">Histórico</span>
    </div>

    <!-- Card principal -->
    <div class="bg-white rounded-2xl shadow-sm overflow-hidden" style="border: 1px solid var(--flua-borda)">

      <!-- Header roxo -->
      <div class="px-6 py-4 flex items-center justify-between" style="background-color: var(--thead)">
        <div class="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="1.5" stroke="white" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
          <span class="font-semibold text-sm text-white">Histórico — Recebimentos em espécie</span>
        </div>
        <button (click)="voltar()" class="p-1 text-white hover:opacity-75">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="2" stroke="currentColor" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Filtros -->
      <div *ngIf="!saldoSelecionado" class="px-6 py-5 grid grid-cols-1 md:grid-cols-4 gap-3 items-end"
           style="border-bottom: 1px solid var(--flua-borda)">
        <div>
          <label class="text-xs font-semibold mb-1 block" style="color: var(--tx)">Caixa</label>
          <select [(ngModel)]="caixaSelecionada"
                  class="w-full px-3 py-2 text-sm rounded-lg"
                  style="border: 1px solid var(--flua-borda); color: var(--tx)">
            <option *ngFor="let c of caixas" [ngValue]="c">
              {{ c.name }} — {{ c.establishmentName }}
            </option>
          </select>
        </div>
        <div>
          <label class="text-xs font-semibold mb-1 block" style="color: var(--tx)">Data inicial</label>
          <input type="date" [(ngModel)]="dataInicio"
                 class="w-full px-3 py-2 text-sm rounded-lg"
                 style="border: 1px solid var(--flua-borda); color: var(--tx)"/>
        </div>
        <div>
          <label class="text-xs font-semibold mb-1 block" style="color: var(--tx)">Data final</label>
          <input type="date" [(ngModel)]="dataFim"
                 class="w-full px-3 py-2 text-sm rounded-lg"
                 style="border: 1px solid var(--flua-borda); color: var(--tx)"/>
        </div>
        <button (click)="buscar()"
                [disabled]="isLoading || !caixaSelecionada"
                class="px-4 py-2 rounded-lg text-xs font-semibold text-white flex items-center justify-center gap-1.5"
                [style.backgroundColor]="isLoading || !caixaSelecionada ? '#D6CFC2' : 'var(--brand-primary)'"
                onmouseover="if(!this.disabled) this.style.backgroundColor='var(--brand-primary)'"
                onmouseout="if(!this.disabled) this.style.backgroundColor='var(--brand-primary)'">
          <div *ngIf="isLoading" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
          {{ isLoading ? 'Buscando...' : 'Aplicar Filtros' }}
        </button>
      </div>

      <!-- Erro -->
      <div *ngIf="erro" class="px-6 py-3">
        <div class="rounded-lg px-3 py-2 text-xs flex items-start gap-2"
             style="background-color: #fef2f2; border: 1px solid #fecaca; color: #991b1b">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="2" stroke="#991b1b" class="size-4 flex-shrink-0 mt-0.5">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
          </svg>
          <span>{{ erro }}</span>
        </div>
      </div>

      <!-- Tabela de saldos -->
      <div *ngIf="!saldoSelecionado && saldos.length > 0" class="overflow-auto" style="max-height: 500px">
        <table class="w-full text-xs">
          <thead class="sticky top-0" style="background-color: var(--thead)">
            <tr>
              <th class="text-left px-3 py-2 font-semibold text-white">Data</th>
              <th class="text-right px-3 py-2 font-semibold text-white">Saldo Inicial</th>
              <th class="text-right px-3 py-2 font-semibold text-white">Saldo Atual</th>
              <th class="text-right px-3 py-2 font-semibold text-white">Entradas</th>
              <th class="text-right px-3 py-2 font-semibold text-white">Saídas</th>
              <th class="text-left px-3 py-2 font-semibold text-white">Fechamento</th>
              <th class="text-center px-3 py-2 font-semibold text-white">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of saldos"
                (click)="verTransacoes(s)"
                class="cursor-pointer hover:bg-gray-50"
                style="border-top: 1px solid var(--flua-borda)">
              <td class="px-3 py-2" style="color: var(--tx)">{{ s.balanceDate | date:'dd/MM/yyyy' }}</td>
              <td class="px-3 py-2 text-right" style="color: var(--tx)">{{ formatCurrency(s.initialBalance) }}</td>
              <td class="px-3 py-2 text-right font-semibold" style="color: var(--brand-primary)">{{ formatCurrency(s.currentBalance) }}</td>
              <td class="px-3 py-2 text-right" style="color: var(--brand-secondary)">{{ formatCurrency(s.ingressBalance) }}</td>
              <td class="px-3 py-2 text-right" style="color: #991b1b">{{ formatCurrency(s.egressBalance) }}</td>
              <td class="px-3 py-2" style="color: var(--tx-2)">
                <span *ngIf="s.closureDate">{{ s.closureDate | date:'dd/MM HH:mm' }} ({{ s.closureUser }})</span>
                <span *ngIf="!s.closureDate" class="italic">Em aberto</span>
              </td>
              <td class="px-3 py-2 text-center">
                <span class="inline-flex items-center gap-1 text-xs font-semibold" style="color: var(--brand-primary)">
                  Ver
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                       stroke-width="2" stroke="currentColor" class="size-3.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
                  </svg>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Drill-down: transações -->
      <div *ngIf="saldoSelecionado" class="px-6 py-5 space-y-3">
        <div class="flex items-center justify-between">
          <button (click)="voltarListaSaldos()"
                  class="flex items-center gap-1 text-xs font-semibold" style="color: var(--brand-primary)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"/>
            </svg>
            Voltar à lista
          </button>
          <div class="flex items-center gap-3">
            <p class="text-xs" style="color: var(--tx-2)">
              Saldo de <strong style="color: var(--tx)">{{ saldoSelecionado.balanceDate | date:'dd/MM/yyyy' }}</strong>
              — caixa {{ caixaSelecionada?.name }} (seq {{ saldoSelecionado.id }})
            </p>
            <button (click)="baixarPdf()" [disabled]="isLoadingTransacoes || transacoes.length === 0"
                    class="px-3 py-1.5 rounded-lg text-xs font-semibold flex items-center gap-1.5"
                    [style.backgroundColor]="isLoadingTransacoes || transacoes.length === 0 ? '#E5DFD4' : 'var(--brand-primary)'"
                    [style.color]="isLoadingTransacoes || transacoes.length === 0 ? '#9AA6AF' : 'white'"
                    [style.cursor]="isLoadingTransacoes || transacoes.length === 0 ? 'not-allowed' : 'pointer'">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                   stroke-width="2" stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"/>
              </svg>
              Baixar PDF
            </button>
            <button *ngIf="!saldoSelecionado.closureDate"
                    (click)="abrirConfirmFechamento()"
                    [disabled]="isFechandoSaldo"
                    class="px-3 py-1.5 rounded-lg text-xs font-semibold flex items-center gap-1.5 text-white"
                    [style.backgroundColor]="isFechandoSaldo ? '#D6CFC2' : '#991b1b'"
                    [style.cursor]="isFechandoSaldo ? 'not-allowed' : 'pointer'">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                   stroke-width="2" stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"/>
              </svg>
              Fechar Saldo
            </button>
          </div>
        </div>

        <div *ngIf="isLoadingTransacoes" class="text-center py-6 text-xs" style="color: var(--tx-2)">
          Carregando transações...
        </div>

        <div *ngIf="!isLoadingTransacoes && transacoes.length === 0"
             class="text-center py-6 text-xs" style="color: var(--tx-2)">
          Nenhuma transação encontrada para este saldo.
        </div>

        <div *ngIf="!isLoadingTransacoes && transacoes.length > 0"
             class="rounded-lg overflow-auto"
             style="border: 1px solid var(--flua-borda); max-height: 480px">
          <table class="w-full text-xs">
            <thead class="sticky top-0" style="background-color: var(--thead)">
              <tr>
                <th class="text-left px-3 py-2 font-semibold text-white">Data</th>
                <th class="text-left px-3 py-2 font-semibold text-white">Tipo</th>
                <th class="text-left px-3 py-2 font-semibold text-white">Transação</th>
                <th class="text-right px-3 py-2 font-semibold text-white">Valor</th>
                <th class="text-left px-3 py-2 font-semibold text-white">Pessoa / Observação</th>
                <th class="text-right px-3 py-2 font-semibold text-white">Recibo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of transacoes" style="border-top: 1px solid var(--flua-borda)">
                <td class="px-3 py-2" style="color: var(--tx)">{{ t.dtAtualizacao | date:'dd/MM HH:mm' }}</td>
                <td class="px-3 py-2" style="color: var(--tx)">{{ t.dsCaixa }}</td>
                <td class="px-3 py-2" style="color: var(--tx-2)">{{ t.dsTransacao }}</td>
                <td class="px-3 py-2 text-right font-semibold"
                    [style.color]="isSangria(t) ? '#dc2626' : 'var(--brand-primary)'">
                  {{ isSangria(t) ? '- ' : '' }}{{ formatCurrency(t.vlTransacao) }}
                </td>
                <td class="px-3 py-2" style="color: var(--tx)">
                  <span *ngIf="t.nome">{{ t.nome }}</span>
                  <span *ngIf="!t.nome && t.dsObservacao" class="italic" style="color: var(--tx-2)">{{ t.dsObservacao }}</span>
                  <span *ngIf="t.dsCaixaDestino" class="block text-[11px]" style="color: var(--tx-2)">→ {{ t.dsCaixaDestino }}</span>
                </td>
                <td class="px-3 py-2 text-right" style="color: var(--tx-2)">{{ t.nrRecibo || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Cancelamentos -->
        <div *ngIf="!isLoadingTransacoes && cancelamentos.length > 0" class="mt-4">
          <div class="flex items-center gap-2 mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="#991b1b" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>
            <h3 class="text-xs font-semibold" style="color: #991b1b">
              Cancelamentos ({{ cancelamentos.length }})
            </h3>
          </div>
          <div class="rounded-lg overflow-auto" style="border: 1px solid #fecaca; max-height: 320px">
            <table class="w-full text-xs">
              <thead class="sticky top-0" style="background-color: #991b1b">
                <tr>
                  <th class="text-left px-3 py-2 font-semibold text-white">Data Cancelamento</th>
                  <th class="text-left px-3 py-2 font-semibold text-white">Transação</th>
                  <th class="text-right px-3 py-2 font-semibold text-white">Valor</th>
                  <th class="text-left px-3 py-2 font-semibold text-white">Paciente</th>
                  <th class="text-left px-3 py-2 font-semibold text-white">Usuário</th>
                  <th class="text-right px-3 py-2 font-semibold text-white">Recibo</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of cancelamentos" style="border-top: 1px solid #fecaca">
                  <td class="px-3 py-2" style="color: var(--tx)">{{ c.dtCancelamento | date:'dd/MM HH:mm' }}</td>
                  <td class="px-3 py-2" style="color: var(--tx-2)">{{ c.dsTransacao || '—' }}</td>
                  <td class="px-3 py-2 text-right font-semibold" style="color: #991b1b">{{ formatCurrency(c.vlEspecie) }}</td>
                  <td class="px-3 py-2" style="color: var(--tx)">{{ c.nmPaciente || '—' }}</td>
                  <td class="px-3 py-2" style="color: var(--tx-2)">{{ c.nmUsuario || '—' }}</td>
                  <td class="px-3 py-2 text-right" style="color: var(--tx-2)">{{ c.nrRecibo || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Modal de confirmação: Fechar Saldo -->
<div *ngIf="showConfirmFechamento" class="fixed inset-0 z-50 flex items-center justify-center"
     style="background-color: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-2xl shadow-xl overflow-hidden" style="width: 420px; max-width: 90vw">
    <div class="px-5 py-4 flex items-center gap-2" style="background-color: #991b1b">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
           stroke-width="2" stroke="white" class="size-5">
        <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
      </svg>
      <span class="text-sm font-semibold text-white">Fechar saldo do caixa</span>
    </div>

    <div class="px-5 py-5 space-y-3">
      <p class="text-sm" style="color: var(--tx)">
        Tem certeza que deseja <strong>fechar</strong> o saldo de
        <strong>{{ saldoSelecionado?.balanceDate | date:'dd/MM/yyyy' }}</strong>
        do caixa <strong>{{ caixaSelecionada?.name }}</strong>?
      </p>
      <p class="text-xs" style="color: var(--tx-2)">
        Esta ação não pode ser desfeita. Não é permitido fechar saldos com recebimentos ou lotes em aberto.
      </p>
      <div *ngIf="feedbackFechamento"
           class="rounded-lg px-3 py-2 text-xs"
           style="background-color: #fef2f2; border: 1px solid #fecaca; color: #991b1b">
        {{ feedbackFechamento }}
      </div>
    </div>

    <div class="px-5 py-4 flex justify-end gap-2" style="border-top: 1px solid var(--flua-borda)">
      <button (click)="fecharConfirmFechamento()"
              [disabled]="isFechandoSaldo"
              class="px-4 py-2 rounded-lg text-xs font-semibold"
              style="border: 1px solid var(--flua-borda); color: var(--tx-2)">
        Cancelar
      </button>
      <button (click)="confirmarFecharSaldo()"
              [disabled]="isFechandoSaldo"
              class="px-4 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
              [style.backgroundColor]="isFechandoSaldo ? '#D6CFC2' : '#991b1b'"
              [style.cursor]="isFechandoSaldo ? 'not-allowed' : 'pointer'">
        <div *ngIf="isFechandoSaldo" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
        {{ isFechandoSaldo ? 'Fechando...' : 'Fechar Saldo' }}
      </button>
    </div>
  </div>
</div>

<!-- Feedback de sucesso -->
<div *ngIf="feedbackFechamento && !showConfirmFechamento && !feedbackFechamento.toLowerCase().includes('erro') && feedbackFechamento.toLowerCase().includes('sucesso')"
     class="fixed bottom-6 right-6 z-50 rounded-lg px-4 py-3 text-xs shadow-lg"
     style="background-color: #dcfce7; border: 1px solid #bbf7d0; color: #166534">
  {{ feedbackFechamento }}
</div>
